module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "rch1",
      "title": "Chapter One: Cast Iron Cooking"
    }
  }, [_c('p', {
    staticClass: "ch-number"
  }, [_c('b', [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch1"
    }
  }, [_vm._v("CHAPTER ONE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch1"
    }
  }, [_c('b', [_vm._v("Cast Iron Cooking")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Whether you’ve been cooking with cast iron for decades or your skillet still has the price tag on the bottom, here’s everything you need to know about cast iron cooking plus a little history on this essential kitchen tool.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-sub"
  }, [_c('b', [_vm._v("History of Cast Iron Cookware")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("The widespread use of iron came around 2,000 BC, long after the original Paleo diet had faded into obscurity. Even then, it was predominantly used in making tools and weapons. The first evidence of cast iron cookware appeared between 200 BC and 200 AD in China, where cast iron pans were used for salt evaporation. It has been used since then in kitchens around the globe. In Japan, teapots made of cast iron, called "), _c('i', [_vm._v("tetsubin,")]), _vm._v(" are heated over a charcoal fire and have been used as early as 1500. In the Netherlands, special techniques using sand to create a smooth, enameled cast iron cookware surface emerged around 1600. The English observed this improved method for making pots and copied the technique in the 1700s, resulting in what has since been called the “Dutch oven.” Cast iron cookware became a staple in European and colonial American kitchens thereafter. In the 1900s, cast iron was upstaged by steel and aluminum cookware, but cast iron aficionados remained loyal, and for good reason.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-sub"
  }, [_c('b', [_vm._v("Benefits of Cast Iron Cookware")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Cast iron pans offer numerous advantages over other cooking vessels, including excellent heat retention, a nonstick surface, affordability, and durability.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("Cast iron pans retain and transmit heat well. By preheating the pan for a few minutes, you can generate a very hot surface useful for producing an excellent sear on meats. This is important because you don’t want a pan’s temperature to drop precipitously when you add food, especially if you’re trying to sauté vegetables or brown meat.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("Well-seasoned cast iron skillets are also naturally nonstick, making them a good option for eggs, paella, and other foods that tend to adhere to cooking surfaces. Conventional nonstick cookware cannot be preheated without damaging the surface of the pan and generating a slew of chemicals into the air, and they don’t produce a good sear. Cast iron offers both nonstick and superior browning capabilities.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("Cast iron pans are also inexpensive, especially when compared to high-end cookware used by professional chefs. You might already have a cast iron skillet in your attic or be able to pick one up at a garage sale. Because the pan is a solid piece of metal, it is virtually indestructible and can last for generations.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("Cast iron cooking also imparts the mineral iron into foods. For some individuals, particularly premenopausal women, this is a desirable feature. However, if you’re following a Paleo diet and eating plenty of red meat and organ meats, you may already have ample iron stores.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-sub"
  }, [_c('b', [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("How to Choose a Cast Iron Skillet")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("You can find cast iron cookware ranging in price from less than $20 to well over $200. The differences will be more apparent depending on your level of experience working with the cast iron skillet and your expectations of the pan. Some features to consider:")]), _vm._v(" "), _c('p', {
    staticClass: "ch-sec"
  }, [_vm._v("Size")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Choose a cast iron skillet that is about the same size as your heat source, especially if you’re cooking on an electric stove. A skillet that overhangs by a few inches on each side, especially if it is a less-expensive model, will not transmit heat throughout the pan as well and may have hot spots. For the recipes in this book, I used a 12-inch skillet.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-sec"
  }, [_vm._v("Finish")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Cast iron skillets with an enamel finish do not require preseasoning and are easier to clean. Enamel is also nonreactive, so tomato and other acidic sauces do not leach metallic flavors into the food.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("Enamel does not retain the flavors of years of seasoning and doesn’t offer the same level of nonstick capacity of unenameled cast iron. Enameled cast iron also doesn’t impart iron to the foods, which may or may not be a desirable feature.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-sec"
  }, [_vm._v("Price")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("If you’re eager to get started without a significant investment, go for an economical pan. Lodge makes inexpensive cast iron skillets that are available online and in most home goods stores such as Target and Walmart. Le Creuset and Staub offer more expensive cast iron cookware in a wide variety of sizes and attractive finishes. They are available online and in fine cooking stores, such as Sur la Table and Williams-Sonoma.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-sec"
  }, [_vm._v("Ergonomics")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("The cast iron skillet is heavy and may require two hands (not to mention pot holders) to move from stove top to oven. Two ergonomic handles can make this easier.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-sub"
  }, [_c('b', [_vm._v("Seasoning Your Cast Iron Skillet")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("If you choose an enamel-finish cast iron pan, no seasoning is required. However, if your pan has a matte black finish, you should season it before your first use and plan your first few recipes to be high-fat, low-acid dishes without potent flavors, such as fish.")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "grey"
  }, [_vm._v("1.")]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Remove stickers from the pan and wash with hot, soapy water to remove dust and residue. Rinse and thoroughly dry with a towel.")])]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "grey"
  }, [_vm._v("2.")]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Coat the inside and outside of the skillet with a neutral flavored oil, such as palm shortening, macadamia oil, or avocado oil.")])]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_c('span', {
    staticClass: "grey"
  }, [_vm._v("3.")]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Place the skillet upside down in a preheated 325°F oven, setting a sheet of aluminum foil on the bottom rack of the oven to catch any drops of oil.")])])]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "grey"
  }, [_vm._v("4.")]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Bake for one hour and then turn off the heat. Allow the skillet to cool in the oven.")])]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "grey"
  }, [_vm._v("5.")]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Wipe the exterior of the skillet with a paper towel to remove any extra oil.")])]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "grey"
  }, [_vm._v("6.")]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("It is now ready to use.")])]), _vm._v(" "), _c('p', {
    staticClass: "ch-sub"
  }, [_c('b', [_vm._v("Caring for Your Cast Iron Skillet")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Enamel-finished skillets can be cleaned in the same way you clean your other cookware, by hand with hot soapy water.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("Seasoned cast iron skillets should not be cleaned with dish soap because it strips the seasoning and oils from the pan. Instead use hot water and a kitchen scrub brush. For stuck-on pieces of food, use a teaspoon of coarse salt and a paper towel to scrub it away. Dry thoroughly inside and out before storing the cast iron skillet to prevent rust. After the first several uses, rub the inside of the clean skillet with a few drops of oil while it is still warm from cleaning before you put it away.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00149478","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter1.vue
// module id = 75
// module chunks = 0